import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
    leads: {},
    error: null,
    loading: false,
    
}


const dialLeadStart = (state,action) =>{
    return updateObject(state, {loading: true})
}

const dialLeadSuccess = (state, action) =>{
return updateObject(state, {
    leads: action.manualLeads, 
    loading : false,
    error: null,
});
};

const dialDataFail = (state, action) =>{
    return updateObject(state, {error: action.error, loading: false});
}

const reducer = (state = initialState, action) =>{
    switch(action.type){
        case actionTypes.MANUAL_LEAD_START:
          return dialLeadStart(state,action);
        case actionTypes.MANUAL_LEAD_SUCCESS:
          return dialLeadSuccess(state,action);
        case actionTypes.MANUAL_LEAD_FAIL:
            return dialDataFail(state,action);
        default:
        return state;

    }
}

export default reducer